// extracted by mini-css-extract-plugin
export var inline = "_vb-0";